import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID} from '@angular/core';

/**
 * Servicio de validación de acceso para guards de autenticación.
 * Comprueba que existan tanto el token como el rol en `localStorage`,
 * siendo compatible con SSR mediante la comprobación de `isPlatformBrowser`.
 */
@Injectable({ providedIn: 'root' })
export class LoginGuardService {
  private readonly platformId:Object = inject(PLATFORM_ID)



  /**
   * Verifica si el usuario tiene una sesión activa válida.
   * Solo funciona en el navegador; en SSR retorna `false` de forma segura.
   * @returns `true` si existen `token` y `role` en `localStorage`.
   */
  accessLogin(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      const role = localStorage.getItem('role');

      return !!(token && role);
    }

    return false; 
  }

  
}
